import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { EXTRACT_ENTITY_ERROR_LOGS_KEY, STEP_EXECUTION_LOGS_KEY } from '@/utils/queryKeys.ts';
import { get_extract_entity_error_logs_url, get_step_execution_logs_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { StepExecutionLogs } from '@/types/stepExecutions.ts';

// export type LogsType = 'default' | 'child' | 'extract_errors' | 'extract_entity_errors';
export type LogsType = 'default' | 'extract_entity_errors';

const getUrl = (logItemId: string | undefined, type: LogsType) => {
  if (type === 'default') {
    return get_step_execution_logs_url(logItemId);
  }
  // else if (type === 'child') {
  //   return get_step_execution_child_logs_url(stepExecutionId);
  // } else if (type === 'extract_errors') {
  //   return get_step_execution_extract_error_logs_url(stepExecutionId);
  // }
  else if (type === 'extract_entity_errors') {
    return get_extract_entity_error_logs_url(logItemId);
  } else {
    throw new Error(`Unknown log type: ${type}`);
  }
};

export const getQueryKey = (
  automationId: string,
  parentId: string | undefined,
  type: LogsType,
) => {
  if (type === 'default') {
    return STEP_EXECUTION_LOGS_KEY(automationId, parentId);
  } else if (type === 'extract_entity_errors') {
    return EXTRACT_ENTITY_ERROR_LOGS_KEY(automationId, parentId);
  } else {
    throw new Error(`Unknown log type: ${type}`);
  }
};

const useRetrieveStepExecutionLogs = (
  logItemId: string | undefined,
  enabled: boolean,
  logsType: LogsType,
) => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();

  return useQuery<StepExecutionLogs, AxiosError>({
    queryKey: getQueryKey(automationId, logItemId, logsType),
    queryFn: async () => {
      const response = await apiClient.get<StepExecutionLogs>(getUrl(logItemId, logsType));
      return response.data;
    },
    enabled: !!logItemId && enabled,
  });
};

export default useRetrieveStepExecutionLogs;
